<template>
	<header class="web_header g-s-a-w">
		<!-- 登录入口 -->
		<div class="web-top">
			<div class="g-f-w web-top-content">
				<el-popover placement="bottom-end" v-model="showLang" :visible-arrow="false" trigger="hover" popper-class="pop-lang">
					<span slot="reference" class="language">
						English<img src="@/assets/english-images/header-img/arrow.png" alt="" class="img">
					</span>
					<div>
						<div class="item" @click="showLang = false">English</div>
						<div class="item" @click="onClicZ()">简体中文</div>
					</div>
				</el-popover>
			</div>
		</div>

		<div class="g-f-w">
			<div class="logo">
				<img src="../../../assets/english-images/header-img/logo-38.svg" />
			</div>
			<ul class="web-nav">
				<li @click="toURL()">Home</li>
				<li>
					<!--  -->
					<!--  -->
					<el-popover placement="bottom-start" :visible-arrow="false" trigger="hover">
						<span slot="reference">Product & Services</span>
						<div class="web-service">
							<!-- 快递-->
							<div class="express">
								<div class="service-title">
									<i class="el-icon-truck"></i>
									<span style="font-weight: bold">Express Services</span>
								</div>
								<div class="servie-list">
									<ul class="ul-guonei">
										<!--<div class="t" @click="routerLinkdd('domestic')">国内</div>-->
										<div class="t">Domestic Service</div>
										<li v-for="(item, index) in country" :key="index">{{ item.edition }}</li>
									</ul>

									<ul class="ul-guoji">
										<!--<div class="t" @click="routerLinkdd('international')">国际</div>-->
										<div class="t">International Service</div>
										<li v-for="(item, index) in productNation" :key="index">{{ item.edition }}</li>
										<li>>>Learn more</li>
									</ul>
									<ul class="ul-add">
										<!--<div class="t" @click="routerLinkdd('addservices')">增值服务</div>-->
										<div class="t">Value-added Services</div>
										<li v-for="(item, index) in appreciation" :key="index">{{ item.edition }}</li>
									</ul>

								</div>
							</div>

							<div class="divider"></div>

							<!-- 物流-->
							<div class="logistics">
								<div class="service-title">
									<!--<i class="el-icon-truck"></i>-->
									<img src="../../../assets/english-images/header-img/home_logistics.png"
										style="margin-right: 12px;width: 22px;" />
									<span style="font-weight: bold">Logistics Services</span>
								</div>
								<div class="servie-list">
									<ul>
										<li @click="tiaoyemain('storage')">Warehouse Service</li>
										<li @click="tiaoyemain('transportation_and_delivery')">Transportation and
											Delivery</li>
										<li @click="tiaoyemain('entrance_and_production_exchange')">Inbound and
											Production Logistics</li>
										<li @click="tiaoyemain('market_and_after_sales')">Sales and After-sales Services
										</li>
										<li @click="tiaoyemain('logisticss')">Supply Chain Finance</li>
										<li @click="tiaoyemain('supply_chain_consult')">Supply Chain Consulting Services
										</li>
										<li @click="tiaoyemain('informationalized_service')">Supply Chain
											Informationization Services
										</li>
									</ul>
								</div>
							</div>

							<!-- 其他部分toLog -->
							<ul class="other-part">
								<div class="send-it" @click="">Shipping</div>
								<li @click="tiaoyemain('freight_prescription')">Rates & Transit Time</li>
								<li @click="tiaoyemain('outlet_inquiry')">Services Points</li>
								<li @click="tiaoyemain('Taboo_items')">Prohibitions</li>
								<li @click="tiaoyemain('services_support')">Services Support</li>
								<!-- <div class="protocol-acct" @click="toagreement">协议客户下单</div> -->
							</ul>
						</div>
					</el-popover>
				</li>

				<!--  toLog -->
				<li>
					<el-popover placement="bottom-start" :visible-arrow="false" trigger="hover">
						<span slot="reference">Services Support</span>
						<div class="web-service">
							<div class="express">
								<div class="servie-list">
									<ul>
										<li @click="">Shipping</li>
										<li @click="tiaoyemain('queryList')">Track and Trace</li>
										<li @click="tiaoyemain('freight_prescription')">Rates & Transit Time</li>
										<li @click="tiaoyemain('Taboo_items')">Prohibitions</li>
										<li @click="tiaoyemain('outlet_inquiry')">Services Points</li>
										<li @click="tiaoyemain('services_support')">For More Inquiry</li>
									</ul>
								</div>
							</div>
						</div>
					</el-popover>
				</li>

				<li>
					<el-popover placement="bottom-start" :visible-arrow="false" trigger="hover">
						<span slot="reference">Industry Logistics Solutions</span>
						<div class="web-service">
							<!-- 快递-->
							<div class="express">
								<div class="servie-list">
									<ul>
										<li @click="tiaoyemain('business_capability')">
											Warehousing Capability
										</li>
										<li @click="tiaoyemain('supply_chain')">
											Supply Chain Finance
										</li>
										<li @click="tiaoyemain('logistics_industry_solutions')">
											logistics industrial solution
										</li>
										<li @click="tiaoyemain('logistics_service_module_solution')">
											logistics modular solution
										</li>
										<li @click="tiaoyemain('e_commerce_platform')">
											E-commerce Platform Cooperation Cases
										</li>
									</ul>
								</div>
							</div>
						</div>
					</el-popover>
				</li>
				<li>
					<el-popover placement="bottom-start" :visible-arrow="false" trigger="hover">
						<span slot="reference">Convenience Services</span>
						<div class="web-service">
							<div class="express">
								<div class="servie-list">
									<ul>
										<li @click="tiaoyemain('convenient_service')">Covenience Services</li>
										<li @click="tiaoyemain('shopping_area')">Shopping Section</li>
										<li @click="tiaoyemain('huinong_district')">Agriculture Cooperated Section</li>
									</ul>
								</div>
							</div>
						</div>
					</el-popover>
				</li>

				<li>
					<el-popover placement="bottom-start" :visible-arrow="false" trigger="hover">
						<span slot="reference">Smart Logistics</span>
						<div class="web-service">
							<div class="express">
								<div class="servie-list">
									<ul>
										<li @click="tiaoyemain('drone')">
											UAVs
										</li>
										<li @click="tiaoyemain('agvprocessingcenter')">
											AGV Processing Center
										</li>
										<li @click="tiaoyemain('autonomoustruck')">
											Self-Driving Trucks
										</li>
										<li @click="tiaoyemain('enddeliveryunmanned')">
											Delivery Unmanned Vehicle
										</li>
									</ul>
								</div>
							</div>
						</div>
					</el-popover>
				</li>

				<li>
					<el-popover placement="bottom-start" :visible-arrow="false" trigger="hover">
						<span slot="reference">About Us</span>
						<div class="web-service">
							<div class="express">
								<div class="servie-list">
									<ul>
										<li @click="tiaoyemain('companyintroduction')">About Company</li>
										<li @click="tiaoyemain('newsandinformation')">News</li>
										<li @click="changePage('/AboutChinaPostalAirlines')">About China Postal Airlines</li>
										<li @click="tiaoyemain('developmentcourse')">Development</li>
										<li @click="tiaoyemain('promotionzone')">Promotion Sector</li>
									</ul>
								</div>
							</div>
						</div>
					</el-popover>
				</li>
			</ul>
		</div>
	</header>
</template>

<script>
//	import Login from "./login.vue";
import Vue from 'vue';
import { Message, Popover, Breadcrumb, BreadcrumbItem } from 'element-ui';
import moment from "moment";
let Base64 = require('js-base64').Base64
Vue.prototype.$message = Message;
Vue.use(Popover);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);

export default {
	inject: ["reload"],
	name: "top-menu",
	// props: {
	// 	msg: String,
	// },
	// props:['window.host'],
	data() {
		return {
			country: [],
			productNation: [],
			appreciation: [],
			logistics: [],
			overseasWarehouse: [],
			overseasWarehousedata: [],
			loginTimer: null,
			loginTimerT: null,
			showLang: false, //显示语言选择
		};
	},
	//		components: {
	//			Login,
	//		},
	mounted() {
		this.init();
		window.scrollTo(0, 0);
	},

	methods: {
		init() {
			let chan = {
				value: {},
			};
			this.$axios
				.post("/cardQuery/showCardQuery", chan)
				.then((res) => {
					this.country = res.value.country;
					this.productNation = res.value.productNation;

					// 增值服务
					this.appreciation = res.value.appreciation;
					for (let i = 0; i < res.value.overseasWarehouse[0].中邮海外仓.length; i++) {
						this.overseasWarehouse.push(res.value.overseasWarehouse[0].中邮海外仓[i]);
					}
					for (let i = 0; i < res.value.overseasWarehouse[1].中邮海外购.length; i++) {
						this.overseasWarehousedata.push(res.value.overseasWarehouse[1].中邮海外购[i]);
					}
					// 物流
					this.logistics = res.value.logistics;
				})
				.catch((err) => {
					this.$message.error(err.data.message);
				});
		},
		// 跳到国内的详情
		toCountry(country_id, router) {
			if (this.$route.name == 'otherHeader') {
				window.parent.location.href = location.origin + this.$router.resolve({
					name: router,
				}).href
			} else {
				this.$router.push({
					name: router,
				});
			}

			if (router == "") {
				alert("暂无数据");
			} else {
				this.$router.push({
					name: router,
				});
			}
			this.reload();
		},
		// 跳到增值服务的详情
		toAddService(country_id, router) {
			if (this.$route.name == 'otherHeader') {
				window.parent.location.href = location.origin + this.$router.resolve({
					name: router,
				}).href
			} else {
				this.$router.push({
					name: router,
				});
			}

			if (router == "") {
				alert("暂无数据");
			} else {
				this.$router.push({
					name: router,
				});
			}
			this.reload();
		},
		// 跳到国际的详情
		toNation(nation_id, router) {

			if (this.$route.name == 'otherHeader') {
				window.parent.location.href = location.origin + this.$router.resolve({
					name: router,
				}).href
			} else {
				this.$router.push({
					name: router,
				});
			}

			if (router == "" || router == undefined) {
				this.$message({
					showClose: true,
					message: '暂无内容',
					type: 'error'
				});
			} else {

				this.$router.push({
					name: router,
				});
			}
			this.reload();
		},
		routerLinkdd(link) {
			this.$router.push(link);
		},
		// 首页
		toURL() {

			if (this.$route.name == 'otherHeader') {
				window.parent.location.href = location.origin + this.$router.resolve({
					path: "/",
				}).href
			} else {
				this.$router.push({
					path: "/",
				});
			}

		},
		// 跳页面
		tiaoyemain(main) {
			//				if(this.$route.name == 'otherHeader') {
			//					window.parent.location.href = location.origin + this.$router.resolve({
			//						name: main,
			//					}).href
			//				} else {
			//					this.$router.push({
			//						name: main,
			//					});
			//				}
			//				this.reload();
		},
		changePage(path) {
			this.$router.push({
				path
			})
		},
		toLog() {
			if (localStorage.getItem("sta_tus") == "false") {
				// 没有登录
				// console.log("没有登录");
				this.loginTimerOut();
				window.open("/pc/main/new/#/order/v2/index");
			} else {

				window.open("/pc/main/new/#/order/v2/index");
			}
			var Traffic = {
				value: {
					ip: returnCitySN['cip'],
					area: returnCitySN['cname'],
					cookies: this.$cookies.get("ecun"),
					modelPath: 'pc/order/product',
					modelName: Base64.encode('我要寄件'),
					createData: moment().format("YYYY-MM-DD HH:mm:ss"),
					onlineTime: '',
					phonePcFlag: this.$store.state.message
				},
			};
			this.$axios
				.post("/userTrafficStatistics/getUserTrafficStatistics", Traffic)
				.then((res) => {

				})
				.catch((err) => {

				});

		},
		loginTimerOut() {
			this.loginTimer = setTimeout(() => {
				localStorage.setItem("num", "2");
				this.$router.go(0);
			}, 10000)
		},
		loginTimerOutT() {
			this.loginTimerT = setTimeout(() => {
				localStorage.setItem("num", "1");
				this.$router.go(0);
			}, 20000)
		},

		// toagreement() {
		// 	window.open("https://my.ems.com.cn/pcp-web/f/login");
		// },

		onClicZ() {
			window.location.href = window.location.origin;
		},

	},
};
</script>

<style lang="scss">
	/* .el-popover {
		top: 54px !important;
	} */
	.pop-lang.el-popper.el-popover {
		min-width: 120px;
		margin-top: 5px;
		padding: 0;
		.item {
			height: 32px;
			line-height: 32px;
			padding: 0 10px;
			color: #333;
			cursor: pointer;
			&:hover {
				background-color: #e0f1ff;
            	color: #1890ff;
			}
		}
	}
</style>

<style lang="scss" scoped>
	.el-menu-vertical-demo:not(.el-menu--collapse) {
		width: 200px;
		min-height: 400px;
	}
	$navHeight: 70px;
	.web-top {
		height: 30px;
		background-color: #1890FF;
		.web-top-content {
			height: 100%;
			display: flex;
    		justify-content: flex-end;
			align-items: center;
			.language {
				color: #fff;
				cursor: pointer;
				display: flex;
				align-items: center;
			}
			.img {
				width: 20px;
				margin-left: 2px;
				filter: brightness(10);
				cursor: pointer;
			}
		}
	}
	.web_header {
		width: 100%;
		background: #ffffff;
		
		>div {
			display: flex;
			align-items: center;
			/*padding: 0 80px;*/
		}
		.logo {
			width: 268px;
			margin-right: 60px;
			flex-shrink: 0;
			height: 45px;
			display: flex;
		}
		.web-nav {
			flex: 1;
			display: flex;
			align-items: center;
			list-style-type: none;
			
		
			li {
				font-size: 14px;
				color: #333;
				cursor: pointer;
				height: $navHeight - 6px;
				line-height: $navHeight - 6px;
				border-bottom: 2px solid white;
				list-style-type: none;
				+li {
					margin-left: 30px;
					list-style-type: none;
				}
				span {
					height: $navHeight - 16px;
					display: inline-block;
					list-style-type: none;
				}
				&:hover {
					color: #004b9c;
					border-color: #004b9c;
				}
			}
		}
		
	}
	/* 产品服务 */
	
	.el-popover .web-service {
		padding: 8px 18px;
		display: flex;
		.divider {
			border-right: 1px solid #d8d8d8;
			margin-right: 30px;
		}
		.express{
			font-size: 16px;
			color: #000;
			display: flex;
			flex-direction: column;
			.service-title {
				display: flex;
				align-items: center;
				margin-bottom: 15px;
				i {
					font-size: 24px;
					margin-right: 10px;
				}
			}
			.servie-list {
				display: flex;
				list-style-type: none;
				
				>ul {
					font-size: 12px;
					width: 230px;
					list-style-type: none;
					box-sizing: border-box;
					padding: 0 10px 0 10px;
					// word-wrap: break-word;   normal | break-all | 
					  word-break : keep-all;
					  text-align: left;
					.t {
						margin-bottom: 10px;
						height: 19px;
						color: #000000;
						font-size: 14px;
						font-weight: bold;
						cursor: pointer;
					}
					li {
						color: #666;
						line-height: 30px;
						cursor: pointer;
						// word-wrap: break-word;
						&:hover {
							color: #1359a3;
						}
					}
				}
				
				.ul-guonei {
					font-size: 12px;
					width: 210px;
					list-style-type: none;
					box-sizing: border-box;
					padding: 0 10px 0 10px;
					// word-wrap: break-word;   normal | break-all | 
					  // word-break : keep-all;
					.t {
						margin-bottom: 10px;
						height: 19px;
						color: #000000;
						font-size: 14px;
						font-weight: bold;
						cursor: pointer;
					}
					li {
						color: #666;
						line-height: 30px;
						cursor: pointer;
						// word-wrap: break-word;
						&:hover {
							color: #1359a3;
						}
					}
				}
				.ul-guoji {
					font-size: 12px;
					width: 224px;
					list-style-type: none;
					box-sizing: border-box;
					padding: 0 10px 0 10px;
					// word-wrap: break-word;   normal | break-all | 
					 // word-break : keep-all;
					.t {
						margin-bottom: 10px;
						height: 19px;
						color: #000000;
						font-size: 14px;
						font-weight: bold;
						cursor: pointer;
					}
					li {
						color: #666;
						line-height: 30px;
						cursor: pointer;
						// word-wrap: break-word;
						&:hover {
							color: #1359a3;
						}
					}
				}
				.ul-add {
					font-size: 12px;
					width: 190px;
					list-style-type: none;
					box-sizing: border-box;
					padding: 0 10px 0 10px;
					// word-wrap: break-word;   normal | break-all | 
					 // word-break : keep-all;
					.t {
						margin-bottom: 10px;
						height: 19px;
						color: #000000;
						font-size: 14px;
						font-weight: bold;
						cursor: pointer;
					}
					li {
						color: #666;
						line-height: 30px;
						cursor: pointer;
						// word-wrap: break-word;
						&:hover {
							color: #1359a3;
						}
					}
				}
			}
			
			
		}
		
		// .expressIN{
		// 	font-size: 16px;
		// 	color: #000;
		// 	display: flex;
		// 	flex-direction: column;
		// 	.service-title {
		// 		display: flex;
		// 		align-items: center;
		// 		margin-bottom: 15px;
		// 		i {
		// 			font-size: 24px;
		// 			margin-right: 10px;
		// 		}
		// 	}
		// 	.servie-list {
		// 		display: flex;
		// 		list-style-type: none;
		// 		>ul {
		// 			font-size: 12px;
		// 			width: 230px;
		// 			list-style-type: none;
		// 			box-sizing: border-box;
		// 			padding: 0 10px 0 10px;
		// 			// word-wrap: break-word;   normal | break-all | 
		// 			 // word-break : keep-all;
		// 			.t {
		// 				margin-bottom: 10px;
		// 				height: 19px;
		// 				color: #000000;
		// 				font-size: 14px;
		// 				font-weight: bold;
		// 				cursor: pointer;
		// 			}
		// 			li {
		// 				color: #666;
		// 				line-height: 30px;
		// 				cursor: pointer;
		// 				// word-wrap: break-word;
		// 				&:hover {
		// 					color: #1359a3;
		// 				}
		// 			}
		// 		}
		// 	}
			
			
		// }
		.logistics {
			font-size: 16px;
			color: #000;
			display: flex;
			flex-direction: column;
			.service-title {
				display: flex;
				align-items: center;
				margin-bottom: 15px;
				i {
					font-size: 24px;
					margin-right: 10px;
				}
			}
			.servie-list {
				display: flex;
				list-style-type: none;
				>ul {
					font-size: 12px;
					width: 214px;
					list-style-type: none;
					box-sizing: border-box;
					padding: 0 10px 0 0px;
					// word-wrap: break-word;   normal | break-all | 
					word-break : keep-all;
					text-align: left;
					.t {
						margin-bottom: 10px;
						height: 19px;
						color: #000000;
						font-size: 14px;
						font-weight: bold;
						cursor: pointer;
					}
					li {
						color: #666;
						line-height: 30px;
						cursor: pointer;
						word-wrap: break-word;
						&:hover {
							color: #1359a3;
						}
					}
				}
			}
		}
		.other-part {
			display: flex;
			width: 160px;
			background-color: #f8f8f8;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			line-height: 30px;
			margin: -20px -20px -20px 0;
			li,
			div {
				cursor: pointer;
				&:hover {
					color: #1359a3;
				}
			}
			>div {
				border: 1px solid #1359a3;
				color: #1359a3;
				font-size: 16px;
				padding: 5px 20px;
				margin: 15px 0;
				border-radius: 30px;
			}
		}
	}
	
</style>